(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar-static"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", () => {
  const slider = document.querySelector(".announcement-bar-static__slider");
  if (!slider) return;

  const track = slider.querySelector(".announcement-bar-static__track");
  const slides = track.querySelectorAll(".announcement-bar-static__slide");
  const total = slides.length;

  if (total <= 1) return; // нет смысла включать слайдер

  let index = 0;

  setInterval(() => {
    index = (index + 1) % total;
    track.style.transform = `translateX(-${index * 100}%)`;
  }, 5000); // 3 секунды
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gallery-for-product"] && !Shopify.designMode) return;
  try {
    
const askButtonGalery = document.querySelector('.gallery-for-product__button_popup-open');
const notifyPopup = document.getElementById("popup-notify-me");
const closeButtonNotify = document.querySelector('.popup__close-button_notify');

function openPopup(popup) {
	popup.classList.add('popup_opened');
    textAreaValue.value = "";
    announBar.classList.add('announcement-bar_hide');
	document.addEventListener('keydown', closeByEscape);
  }
  
  function closePopup (popup) {
    console.log(announBar);
    announBar.classList.remove('announcement-bar_hide');
	popup.classList.remove('popup_opened');
	document.removeEventListener('keydown', closeByEscape);
  }

  function closeByEscape (evt) {
    if (evt.key === 'Escape') {
        const openedPopup = document.querySelector('.popup_opened');
        closePopup(openedPopup);
    }
}

function closeByOverlay (evt) {
    if (evt.target === evt.currentTarget) {
      const openedPopup = document.querySelector('.popup_opened');
        closePopup(openedPopup);
           }
     }

  askButtonGalery.addEventListener('click', () => openPopup(notifyPopup));
  closeButtonNotify.addEventListener('click', () => closePopup(notifyPopup))

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["guide-slider"] && !Shopify.designMode) return;
  try {
    
      
let plusSrc = "https://cdn-icons-png.flaticon.com/512/748/748113.png";
let munisSrc = "https://cdn-icons-png.flaticon.com/512/2801/2801932.png"

const slider1 = document.getElementById("1")
      const slider2 = document.getElementById("2")
      const slider3 = document.getElementById("3")
      const slider4 = document.getElementById("4")
      const slider5 = document.getElementById("5")
      const slider6 = document.getElementById("6")
      const slider7 = document.getElementById("7")
      const slider8 = document.getElementById("8")
      const slider9 = document.getElementById("9")
      const slider10 = document.getElementById("10")
      //buttons plus-minus
      const plusminus1 = document.getElementById("plus-minus-1")
      const plusminus2 = document.getElementById("plus-minus-2")
      const plusminus3 = document.getElementById("plus-minus-3")
      console.log(plusminus3);  
      const plusminus4 = document.getElementById("plus-minus-4")
      const plusminus5 = document.getElementById("plus-minus-5")
      const plusminus6 = document.getElementById("plus-minus-6")
      const plusminus7 = document.getElementById("plus-minus-7")
      const plusminus8 = document.getElementById("plus-minus-8")
      const plusminus9 = document.getElementById("plus-minus-9")
      const plusminus10 = document.getElementById("plus-minus-10")

    
      function preloadSlider () {
        slider1.style.display = "block";
          slider2.style.display = "none";
          slider9.style.display = "none";
          slider10.style.display = "none";
          slider7.style.display = "none";
          slider6.style.display = "none";
          slider5.style.display = "none";
          slider4.style.display = "none";
          slider3.style.display = "none";
          slider8.style.display = "none";
          plusminus2.src = plusSrc
          plusminus3.src = plusSrc
          plusminus4.src = plusSrc
          plusminus5.src = plusSrc
          plusminus6.src = plusSrc
          plusminus7.src = plusSrc
          plusminus8.src = plusSrc
          plusminus9.src = plusSrc
          plusminus10.src = plusSrc
      }
      preloadSlider();

let allButt = []
function takeAllPlusMinus () {
    // find all plus-minus buttons
    document.querySelectorAll('.diamonds-slider__switch-figure').forEach(button => {
        return allButt.push(button)
    })
}

takeAllPlusMinus()
    function checkSlider () {
        document.querySelectorAll('.diamonds-slider-2').forEach(slider => {
            document.querySelectorAll('.diamonds-slider__switch-figure').forEach(button => {
                if (slider.style.display === "none") {
                  console.log(slider1.style.display)
                  button.src = plusSrc;
            } else if (slider.style.display === "block") {
                button.src = munisSrc;
            }
        })
        })
    }


function  openSlider1 () {
    if (slider1.style.display === "none") {
        slider1.style.display = "block";
        slider2.style.display = "none";
        slider9.style.display = "none";
        slider10.style.display = "none";
        slider7.style.display = "none";
        slider6.style.display = "none";
        slider5.style.display = "none";
        slider4.style.display = "none";
        slider3.style.display = "none";
        slider8.style.display = "none";
        plusminus1.src = munisSrc
        plusminus2.src = plusSrc
        plusminus3.src = plusSrc
        plusminus4.src = plusSrc
        plusminus5.src = plusSrc
        plusminus6.src = plusSrc
        plusminus7.src = plusSrc
        plusminus8.src = plusSrc
        plusminus9.src = plusSrc
        plusminus10.src = plusSrc
    } else if (slider1.style.display === "block") {
        slider1.style.display = "none";
        plusminus1.src = plusSrc
    }
}

function  openSlider2 () {
    console.log(slider2.style.display)
    if (slider2.style.display === "none" || slider1.style.display === "block") {
        slider2.style.display = "block";
        slider9.style.display = "none";
        slider10.style.display = "none";
        slider7.style.display = "none";
        slider6.style.display = "none";
        slider5.style.display = "none";
        slider4.style.display = "none";
        slider3.style.display = "none";
        slider1.style.display = "none";
        slider8.style.display = "none";
        plusminus2.src = munisSrc
        plusminus1.src = plusSrc
        plusminus3.src = plusSrc
        plusminus4.src = plusSrc
        plusminus5.src = plusSrc
        plusminus6.src = plusSrc
        plusminus7.src = plusSrc
        plusminus8.src = plusSrc
        plusminus9.src = plusSrc
        plusminus10.src = plusSrc
    } else if (slider2.style.display === "block") {
        console.log("block")
        slider2.style.display = "none";
        plusminus2.src = plusSrc
    }
}

function  openSlider3 () {
    if (slider3.style.display === "none" || slider1.style.display === "block") {
        console.log("none")
        slider3.style.display = "block";
        slider9.style.display = "none";
        slider10.style.display = "none";
        slider7.style.display = "none";
        slider6.style.display = "none";
        slider5.style.display = "none";
        slider4.style.display = "none";
        slider8.style.display = "none";
        slider2.style.display = "none";
        slider1.style.display = "none";
        plusminus3.src = munisSrc
        plusminus2.src = plusSrc
        plusminus1.src = plusSrc
        plusminus4.src = plusSrc
        plusminus5.src = plusSrc
        plusminus6.src = plusSrc
        plusminus7.src = plusSrc
        plusminus8.src = plusSrc
        plusminus9.src = plusSrc
        plusminus10.src = plusSrc
    } else if (slider3.style.display === "block") {
        console.log("block")
        slider3.style.display = "none";
        plusminus3.src = plusSrc
    }
}

function  openSlider4 () {
    if (slider4.style.display === "none" || slider1.style.display === "block") {
        slider4.style.display = "block";
        slider9.style.display = "none";
        slider10.style.display = "none";
        slider7.style.display = "none";
        slider6.style.display = "none";
        slider5.style.display = "none";
        slider8.style.display = "none";
        slider3.style.display = "none";
        slider2.style.display = "none";
        slider1.style.display = "none";
        plusminus4.src = munisSrc
        plusminus3.src = plusSrc
        plusminus2.src = plusSrc
        plusminus1.src = plusSrc
        plusminus3.src = plusSrc
        plusminus5.src = plusSrc
        plusminus6.src = plusSrc
        plusminus7.src = plusSrc
        plusminus8.src = plusSrc
        plusminus9.src = plusSrc
        plusminus10.src = plusSrc

    } else if (slider4.style.display === "block") {
        slider4.style.display = "none";
        plusminus4.src = plusSrc
    }
}

function  openSlider5 () {
    if (slider5.style.display === "none" || slider1.style.display === "block") {
        slider5.style.display = "block";
        slider9.style.display = "none";
        slider10.style.display = "none";
        slider7.style.display = "none";
        slider6.style.display = "none";
        slider8.style.display = "none";
        slider4.style.display = "none";
        slider3.style.display = "none";
        slider2.style.display = "none";
        slider1.style.display = "none";
        plusminus5.src = munisSrc
        plusminus3.src = plusSrc
        plusminus2.src = plusSrc
        plusminus1.src = plusSrc
        plusminus4.src = plusSrc
        plusminus6.src = plusSrc
        plusminus7.src = plusSrc
        plusminus8.src = plusSrc
        plusminus9.src = plusSrc
        plusminus10.src = plusSrc

    } else if (slider5.style.display === "block") {
        slider5.style.display = "none";
        plusminus5.src = plusSrc
    }
}

function  openSlider6 () {
    if (slider6.style.display === "none" || slider1.style.display === "block") {
        slider6.style.display = "block";
        slider9.style.display = "none";
        slider10.style.display = "none";
        slider7.style.display = "none";
        slider8.style.display = "none";
        slider5.style.display = "none";
        slider4.style.display = "none";
        slider3.style.display = "none";
        slider2.style.display = "none";
        slider1.style.display = "none";
        plusminus6.src = munisSrc
        plusminus5.src = plusSrc
        plusminus3.src = plusSrc
        plusminus2.src = plusSrc
        plusminus1.src = plusSrc
        plusminus4.src = plusSrc
        plusminus7.src = plusSrc
        plusminus8.src = plusSrc
        plusminus9.src = plusSrc
        plusminus10.src = plusSrc

    } else if (slider6.style.display === "block") {
        slider6.style.display = "none";
        plusminus6.src = plusSrc
    }
}

function  openSlider7 () {
    if (slider7.style.display === "none" || slider1.style.display === "block") {
        slider7.style.display = "block";
        slider9.style.display = "none";
        slider10.style.display = "none";
        slider8.style.display = "none";
        slider6.style.display = "none";
        slider5.style.display = "none";
        slider4.style.display = "none";
        slider3.style.display = "none";
        slider2.style.display = "none";
        slider1.style.display = "none";
        plusminus7.src = munisSrc
        plusminus6.src = plusSrc
        plusminus5.src = plusSrc
        plusminus3.src = plusSrc
        plusminus2.src = plusSrc
        plusminus1.src = plusSrc
        plusminus4.src = plusSrc
        plusminus8.src = plusSrc
        plusminus9.src = plusSrc
        plusminus10.src = plusSrc

    } else if (slider7.style.display === "block") {
        slider7.style.display = "none";
        plusminus7.src = plusSrc
    }
}

function  openSlider8 () {
    if (slider8.style.display === "none" || slider1.style.display === "block") {
        slider8.style.display = "block";
        slider9.style.display = "none";
        slider10.style.display = "none";
        slider7.style.display = "none";
        slider6.style.display = "none";
        slider5.style.display = "none";
        slider4.style.display = "none";
        slider3.style.display = "none";
        slider2.style.display = "none";
        slider1.style.display = "none";
        plusminus8.src = munisSrc
        plusminus7.src = plusSrc
        plusminus6.src = plusSrc
        plusminus5.src = plusSrc
        plusminus3.src = plusSrc
        plusminus2.src = plusSrc
        plusminus1.src = plusSrc
        plusminus4.src = plusSrc
        plusminus9.src = plusSrc
        plusminus10.src = plusSrc

    } else if (slider8.style.display === "block") {
        slider8.style.display = "none";
        plusminus8.src = plusSrc
    }
}

function  openSlider9 () {
    if (slider9.style.display === "none" || slider1.style.display === "block") {
        slider9.style.display = "block";
        slider10.style.display = "none";
        slider8.style.display = "none";
        slider7.style.display = "none";
        slider6.style.display = "none";
        slider5.style.display = "none";
        slider4.style.display = "none";
        slider3.style.display = "none";
        slider2.style.display = "none";
        slider1.style.display = "none";
        plusminus9.src = munisSrc
        plusminus8.src = plusSrc
        plusminus7.src = plusSrc
        plusminus6.src = plusSrc
        plusminus5.src = plusSrc
        plusminus3.src = plusSrc
        plusminus2.src = plusSrc
        plusminus1.src = plusSrc
        plusminus4.src = plusSrc
        plusminus10.src = plusSrc
    } else if (slider9.style.display === "block") {
        slider9.style.display = "none";
        plusminus9.src = plusSrc
    }
}

function  openSlider10 () {
    if (slider10.style.display === "none" || slider1.style.display === "block") {
        slider10.style.display = "block";
        slider9.style.display = "none";
        slider8.style.display = "none";
        slider7.style.display = "none";
        slider6.style.display = "none";
        slider5.style.display = "none";
        slider4.style.display = "none";
        slider3.style.display = "none";
        slider2.style.display = "none";
        slider1.style.display = "none";
        plusminus10.src = munisSrc
        plusminus9.src = plusSrc
        plusminus8.src = plusSrc
        plusminus7.src = plusSrc
        plusminus6.src = plusSrc
        plusminus5.src = plusSrc
        plusminus3.src = plusSrc
        plusminus2.src = plusSrc
        plusminus1.src = plusSrc
        plusminus4.src = plusSrc
    } else if (slider10.style.display === "block") {
        slider10.style.display = "none";
        plusminus10.src = plusSrc
    }
}


document.querySelectorAll('.diamonds-slider__img-link-1').forEach(link => {
      link.addEventListener('click', e => {
        if (!e.target.matches('button')) return
        document.querySelector('.pic').src = e.target.dataset.src
    
      })
     document.querySelectorAll('.diamonds-slider__switch-1').forEach(switchLink => {
              switchLink.addEventListener('click', openSlider1);
              plusminus1.addEventListener('click', openSlider1)
      })
    })
      
      document.querySelectorAll('.diamonds-slider__img-link-2').forEach(link => {
      link.addEventListener('click', e => {
        if (!e.target.matches('button')) return
        document.querySelector('.pic2').src = e.target.dataset.src
      })
       document.querySelectorAll('.diamonds-slider__switch-2').forEach(switchLink => {
          switchLink.addEventListener('click', openSlider2)
          plusminus2.addEventListener('click', openSlider2)
      })
      })

     document.querySelectorAll('.diamonds-slider__img-link-3').forEach(link => {
      link.addEventListener('click', e => {
        if (!e.target.matches('button')) return
        document.querySelector('.pic3').src = e.target.dataset.src;
      })
      document.querySelectorAll('.diamonds-slider__switch-3').forEach(switchLink => {
        switchLink.addEventListener('click', openSlider3)
        plusminus3.addEventListener('click', openSlider3)
      })
    })
    
    document.querySelectorAll('.diamonds-slider__img-link-4').forEach(link => {
      link.addEventListener('click', e => {
        if (!e.target.matches('button')) return
        document.querySelector('.pic4').src = e.target.dataset.src;
      })
      document.querySelectorAll('.diamonds-slider__switch-4').forEach(switchLink => {
        switchLink.addEventListener('click', openSlider4)
        plusminus4.addEventListener('click', openSlider4)

      })
    })
    
    document.querySelectorAll('.diamonds-slider__img-link-5').forEach(link => {
      link.addEventListener('click', e => {
        if (!e.target.matches('button')) return
        document.querySelector('.pic5').src = e.target.dataset.src;
      })
      document.querySelectorAll('.diamonds-slider__switch-5').forEach(switchLink => {
        switchLink.addEventListener('click', openSlider5);
        plusminus5.addEventListener('click', openSlider5);
      })
    })
    
    document.querySelectorAll('.diamonds-slider__img-link-6').forEach(link => {
      link.addEventListener('click', e => {
        if (!e.target.matches('button')) return
        document.querySelector('.pic6').src = e.target.dataset.src;
      })
      document.querySelectorAll('.diamonds-slider__switch-6').forEach(switchLink => {
        switchLink.addEventListener('click', openSlider6)
        plusminus6.addEventListener('click', openSlider6)
      })
    })
    
    document.querySelectorAll('.diamonds-slider__img-link-7').forEach(link => {
      link.addEventListener('click', e => {
        if (!e.target.matches('button')) return
        document.querySelector('.pic7').src = e.target.dataset.src;
      })
      document.querySelectorAll('.diamonds-slider__switch-7').forEach(switchLink => {
        switchLink.addEventListener('click', openSlider7);
        plusminus7.addEventListener('click', openSlider7);
      })
    })
    
    document.querySelectorAll('.diamonds-slider__img-link-8').forEach(link => {
      link.addEventListener('click', e => {
        if (!e.target.matches('button')) return
        document.querySelector('.pic8').src = e.target.dataset.src
      })
       document.querySelectorAll('.diamonds-slider__switch-8').forEach(switchLink => {
        switchLink.addEventListener('click', openSlider8);
        plusminus8.addEventListener('click', openSlider8);
      })
    })
    
    document.querySelectorAll('.diamonds-slider__img-link-9').forEach(link => {
      link.addEventListener('click', e => {
        if (!e.target.matches('button')) return
        document.querySelector('.pic9').src = e.target.dataset.src
    
      })
      document.querySelectorAll('.diamonds-slider__switch-9').forEach(switchLink => {
        switchLink.addEventListener('click', openSlider9);
        plusminus9.addEventListener('click', openSlider9);
      })
    })
    
    document.querySelectorAll('.diamonds-slider__img-link-10').forEach(link => {
      link.addEventListener('click', e => {
        if (!e.target.matches('button')) return
        document.querySelector('.pic10').src = e.target.dataset.src
    
      })
     document.querySelectorAll('.diamonds-slider__switch-10').forEach(switchLink => {
        switchLink.addEventListener('click', openSlider10);
        plusminus10.addEventListener('click', openSlider10);
      })
    })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-with-text"] && !Shopify.designMode) return;
  try {
    
  const closeButtonTextWithImage = document.querySelector('.btn--popup_open');
  closeButtonTextWithImage.addEventListener('click', () => openPopup(supportPopup));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["navigation-menu"] && !Shopify.designMode) return;
  try {
    
  const activePage = window.location.pathname;
  const navLinks = document.querySelectorAll(".navigation-menu__link").forEach((a) => {
    console.log(a.href);
    a.href.includes(`${activePage}`) &&
      (a.classList.add("navigation-menu__link_active"), console.log(a));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup-sale"]) return;
  try {
    
  //sale popup
const popup = document.getElementById("popup_sale");
const exitButton = document.getElementById("popup_sale__close-button");
const exitLink = document.getElementById("popup_sale__decline-link")

function showPopup() {
  popup.classList.add("show");
}

function hidePopup() {
  popup.classList.remove("show");
}

function checkUrlForPopup() {
  const currentUrl = window.location.href;

  if (currentUrl.includes("15off")) {
    showPopup();
  }

}
exitButton.addEventListener("click", () => {
  hidePopup();
});

exitLink.addEventListener("click", () => {
  hidePopup();
});
  setTimeout(checkUrlForPopup, 1000)


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;
      theme.ProductBlockManager.loadImages(productRecommendationsSection);
      theme.initAnimateOnScroll();
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
